module.exports = __webpack_public_path__ + "media/images/suche-b1486fc06dfad10852dc10bf0690b24b.svg";